import React from "react";
import { ChevronRight } from "lucide-react";

const DEFAULT_LABELS = ["Verify", "Set up", "Start using"];

/**
 * Renders the 3-step "1·Verify > 2·Set up > 3·Start using" pill row that sits
 * inside the activation CTA card. Matches Figma node 3:6949.
 *
 * @param {{ labels?: string[], activeIndex?: number }} props
 *   labels — defaults to ["Verify", "Set up", "Start using"]
 *   activeIndex — 0-based; the active pill gets a brighter background
 */
const StepperPills = ({ labels = DEFAULT_LABELS, activeIndex = 0 }) => (
  <div className="flex items-center gap-1 flex-wrap">
    {labels.map((label, idx) => {
      const isActive = idx === activeIndex;
      return (
        <React.Fragment key={`${idx}-${label}`}>
          <span
            className={`corp-stepper-pill ${
              isActive ? "corp-stepper-pill--active" : ""
            }`}
          >
            <span>{idx + 1}</span>
            <span className="corp-stepper-dot" aria-hidden="true" />
            <span>{label}</span>
          </span>
          {idx < labels.length - 1 && (
            <ChevronRight
              className="opacity-30 text-white"
              size={12}
              aria-hidden="true"
            />
          )}
        </React.Fragment>
      );
    })}
  </div>
);

export default StepperPills;
